/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ChartType } from '@models/chart.model';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-elements-border-cap-style',
  templateUrl: './theme-option-elements-border-cap-style.component.html',
  styleUrls: ['./theme-option-elements-border-cap-style.component.css']
})
export class ThemeOptionElementsBorderCapStyleComponent {

  @Input() themeOptions: ThemeOptionsClass;
  @Input() serieIndex: number;

  showDetails: boolean;
  color = ItemColor('themes');
  optionType: ThemeOptionType = 'elements_borderCapStyle';

  constructor() {
    this.showDetails = false;
  }

  onValue(value: string, type?: ChartType) {
    this.themeOptions.setSeries(this.optionType, value === 'false' ? false : value, this.serieIndex, type ? [type] : undefined);
  }

  receiveShowDetails(showDetails: boolean) {
    this.showDetails = showDetails;
  }

  values = {
    butt: { style: 'butt', label: 'BUTT' },
    round: { style: 'round', label: 'ROUND' },
    square: { style: 'square', label: 'SQUARE' }
  };

}
